export enum FocusKeysSheet {
  FOCUS_KEY_WATCH_LIVE = 'PLAY',
  FOCUS_KEY_CATCH_UP = 'PLAY_SFF',
  FOCUS_KEY_FAVORITE = 'TOGGLE_FAVORITE',
  FOCUS_KEY_RECORD = 'TOGGLE_NPVR',
  FOCUS_KEY_DELETE_RECORDING = 'DELETE_RECORDING',
  FOCUS_KEY_TRAILER = 'TOGGLE_TRAILER',
  FOCUS_KEY_SHEET_DESCRIPTION = 'SHEET_DESCRIPTION',
  EPISODE_SELECTOR = 'EPISODE_SELECTOR',
  EPISODE_SELECTOR_SEASON_TABS = 'EPISODE_SELECTOR_SEASON_TABS',
  EPISODE_SELECTOR_LIST = 'EPISODE_SELECTOR_LIST'
}

export enum FocusKeysRecordingDialog {
  SERIES = 'RECORDING_DIALOG_SERIES',
  SINGLE = 'RECORDING_DIALOG_SINGLE'
}

export const FOCUSED_EPISODE_MAX_CHARS = 850;

export const getEpisodeCardFocusKey = (episodeId: number, isNextEventforSeries: boolean) =>
  `EPISODE_SELECTOR_EPISODE_${episodeId}_${isNextEventforSeries ? 'NEXT' : 'REG'}`;
